import { useEffect } from 'react';

/**
 * Lightweight replacement for react-helmet: sets `document.title` and updates
 * the meta description tag on mount. Restores the previous values on unmount
 * so each page can declare its own title/description without polluting the
 * global HTML template.
 *
 * Usage:
 *   <PageMeta title="Desenzano — Cosa vedere | YUP" description="…" />
 */
export default function PageMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let metaEl = document.querySelector('meta[name="description"]');
    const prevDesc = metaEl ? metaEl.getAttribute('content') : null;
    if (description) {
      if (!metaEl) {
        metaEl = document.createElement('meta');
        metaEl.setAttribute('name', 'description');
        document.head.appendChild(metaEl);
      }
      metaEl.setAttribute('content', description);
    }

    // Keep the OG title/description in sync so Open Graph previews match
    // the currently-visited page when users share the link.
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const prevOgTitle = ogTitle?.getAttribute('content') || null;
    const prevOgDesc = ogDesc?.getAttribute('content') || null;
    if (title && ogTitle) ogTitle.setAttribute('content', title);
    if (description && ogDesc) ogDesc.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (metaEl && prevDesc != null) metaEl.setAttribute('content', prevDesc);
      if (ogTitle && prevOgTitle != null) ogTitle.setAttribute('content', prevOgTitle);
      if (ogDesc && prevOgDesc != null) ogDesc.setAttribute('content', prevOgDesc);
    };
  }, [title, description]);

  return null;
}
